import React, { ReactNode } from 'react';
import { Panel, PanelBody, PanelHeader } from '.';

export interface FieldsetProps {
  children: ReactNode;
  legend?: ReactNode;
}

export default function Paper({ children, legend }: FieldsetProps) {
  return (
    <Panel>
      {legend && <PanelHeader>{legend}</PanelHeader>}

      <PanelBody>{children}</PanelBody>
    </Panel>
  );
}
